import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/nexus-utilities';
import { Shade } from '../../models/shade/shade';

@Injectable({
  providedIn: 'root',
})
export class ShadeProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/shade';

  public getAllShades(): Observable<ApiResponse<Shade[]>> {
    return this.httpClient.get<ApiResponse<Shade[]>>(`${this.baseUrl}/all`);
  }
}
